import { readLocalStorage, writeLocalStorage } from 'redux/saga/helpers/local-storage';

export const KEY_NAME_USE_TEST = 'cpUsePathToPurchaseTest';
export const KEY_NAME_ACTIVE_OFFER = 'cpActiveOfferId';

export const usePathToPurchaseTest = () => readLocalStorage(KEY_NAME_USE_TEST, false);
export const setPathToPurchaseTest = (useTest = true) => writeLocalStorage(KEY_NAME_USE_TEST, useTest);

export const useActiveOfferId = () => readLocalStorage(KEY_NAME_ACTIVE_OFFER);
export const setActiveOfferId = id => writeLocalStorage(KEY_NAME_ACTIVE_OFFER, id);
